export default {
      id: "borg-8-usage",
      viewBox: "0 0 22 22",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#borg-8",
      toString: function () {
        return this.url;
      }
    }